import { render, staticRenderFns } from "./Error_mobile.vue?vue&type=template&id=624c3cce&scoped=true&"
import script from "./Error_mobile.vue?vue&type=script&lang=js&"
export * from "./Error_mobile.vue?vue&type=script&lang=js&"
import style0 from "./Error_mobile.vue?vue&type=style&index=0&id=624c3cce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624c3cce",
  null
  
)

export default component.exports